import { useCallback } from 'react';
import { useState } from 'react';
import { useCrmActivities } from 'services/CrmApi/queries/useCrmActivities';
import { ECrmActivityType, ISearchActivityRequest } from 'services/CrmApi/types/CrmActivityTypes';
import { ESortOrder } from 'store/common/types';
import { IActivityFiltersAction, IActivityFiltersState, IActivitySortAction } from './useActivityFilters';

export const useActivities = (directoryEntryId: string | undefined, activityFilters: IActivityFiltersState, dispatchActivityFilters: (action: IActivityFiltersAction | IActivitySortAction) => void) => {
  const activityTypesEnabled = Object.keys(activityFilters.flags).filter(
    (key: ECrmActivityType) => activityFilters.flags[key]
  );

  const searchRequest: ISearchActivityRequest = {
    filter: {
      directoryEntryId,
      types: activityTypesEnabled as ECrmActivityType[],
      startDate: activityFilters.filters?.dateRange?.startDate ? `${activityFilters.filters.dateRange.startDate}T00:00:00.000Z` : undefined,
      endDate: activityFilters.filters?.dateRange?.endDate ? `${activityFilters.filters.dateRange.endDate}T23:59:59.999Z` : undefined,
      createdById: activityFilters.filters?.createdById ?? undefined,
      searchTerm: activityFilters.filters?.searchTerm ?? undefined,
    },
    pagination: {
      limit: activityFilters.pagination.limit,
      offset: activityFilters.pagination.offset,
    },
    sort: {
      key: activityFilters.sort.key,
      order: activityFilters.sort.order,
    },
  };
  if (activityFilters.cursor?.limit) {
    searchRequest.cursor = {
      limit: activityFilters.cursor.limit,
    };
  }

  const shouldMakeRequest = activityTypesEnabled.length > 0;
  const { crmActivities, activities } = useCrmActivities(searchRequest, shouldMakeRequest);
  const count = crmActivities.data?.pages[0].data.count ?? 0;

  const handleLoadMore = useCallback(() => {
    if (crmActivities.hasNextPage) {
      crmActivities.fetchNextPage();
    }
  }, [crmActivities]);

  return {
    activities: shouldMakeRequest ? activities : [],
    activitiesCount: shouldMakeRequest ? count : 0,
    handleLoadMore,
    crmActivities,
  };
};
